(function () {
    'use strict';

    angular
        .module('expenses')
        .controller('ExpensesComparativeController', ExpensesComparativeController);
    ExpensesComparativeController.$inject = ['ExpensesService', 'InvoicesService', 'itemCostCenters', '$uibModal', '$scope'];
    function ExpensesComparativeController(ExpensesService, InvoicesService, itemCostCenters, $uibModal, $scope) {
        var vm = this;

        vm.flag                  = false;
        vm.getByFilter           = getByFilter;
        vm.semesterASelected     = '';
        vm.semesterBSelected     = '';
        vm.costCenterSelected    = '';
        vm.categorySelected      = '';
        vm.payee                 = '';

        vm.selectSemesters   = selectSemesters;
        //vm.selectAccounts    = selectAccounts;
        vm.costCenters       = itemCostCenters;
        //vm.selectPayees      = selectPayees;
        vm.formatPercent     = formatPercent;
        vm.selectCategories  = selectCategories;

        vm.modal =  modal;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        /* By Category Graph */
        $scope.expensesByCategory = [];
        $scope.expensesByCategory.push({
            label: "Semester (A)",
            data: [0,0],
            bars : {
                show: true,
                align: "left",
                barWidth: 0.2,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        }, {
            label: "Semester (B)",
            data: [0,0],
            bars: {
                show: true,
                align: "right",
                barWidth: 0.2,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        });

        $scope.expensesByCategoryOptions = {
            yaxis: {
                ticks: [0,0]
            },
            colors: ["#edc240"]
        };
        /* Cost Center Graph */
        $scope.expensesByCostCenter = [];
        $scope.expensesByCostCenter.push({
            label: "Semester (A)",
            data: [0,0],
            bars : {
                show: true,
                align: "left",
                barWidth: 0.2,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        }, {
            label: "Semester (B)",
            data: [0,0],
            bars: {
                show: true,
                align: "right",
                barWidth: 0.2,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        });
        $scope.expensesByCostCenterOptions = {
            yaxis: {
                ticks: [0,0]
            },
            colors: ["#fd2525","#731212"]
        };
        /* Payee graph */
        $scope.expensesByPayee = [];
        $scope.expensesByPayee.push({
            label: "Semester (A)",
            data: [0,0],
            bars : {
                show: true,
                align: "left",
                barWidth: 0.2,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        }, {
            label: "Semester (B)",
            data: [0,0],
            bars: {
                show: true,
                align: "right",
                barWidth: 0.2,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        });
        $scope.expensesByPayeeOptions = {
            yaxis: {
                ticks: [0,0]
            },
            colors: ["#04a9f4", "#005277"]
        };
        /* By Bank Account Graph */
        $scope.expensesByBankAccount = [];
        $scope.expensesByBankAccount.push({
            label: "Semester (A)",
            data: [0,0],
            bars : {
                show: true,
                align: "left",
                barWidth: 0.2,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        }, {
            label: "Semester (B)",
            data: [0,0],
            bars: {
                show: true,
                align: "right",
                barWidth: 0.2,
                lineWidth: 1,
                horizontal: true,
                fill: 1,
                tooltip: true
            }
        });
        $scope.expensesByBankAccountOptions = {
            yaxis: {
                ticks: [0,0]
            },
            colors: ["#8bc24a","#51712b"]
        };

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectSemesters();
            vm.selectCategories();
        }

        function getByFilter() {
            vm.queryFlag = false;
            vm.query = {};
            vm.query['page']    = vm.page;
            if(typeof vm.semesterASelected.id !== 'undefined') {
                vm.query['semesterA'] = vm.semesterASelected.id;
            }
            if(typeof vm.semesterBSelected.id !== 'undefined') {
                vm.query['semesterB'] = vm.semesterBSelected.id;
            }
            if(typeof vm.costCenterSelected.id !== 'undefined') {
                vm.query['costCenter'] = vm.costCenterSelected.id;
                vm.query['costCenterParent'] = vm.costCenterSelected.parent_id;
            }
            if(vm.categorySelected !== '') {
                vm.query['category'] = vm.categorySelected;
            }
            if(vm.payee !== '') {
                vm.query['payee'] = vm.payee;
            }
            ExpensesService.getExpensesComparative(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.expenses         = response.data;

                // By Category Graph
                var valuesa = [];
                var valuesb = [];
                var labels = [];
                angular.forEach(response.data.expensesByCategory.graph.values.a, function(value, key) {
                    valuesa.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByCategory.graph.values.b, function(value, key) {
                    valuesb.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByCategory.graph.labels, function(value, key) {
                    labels.push(value);
                });
                $scope.expensesByCategory = [{
                    label: vm.semesterASelected.name,
                    data: valuesa,
                    bars : {
                        show: true,
                        align: "left",
                        barWidth: 0.2,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }, {
                    label: vm.semesterBSelected.name,
                    data: valuesb,
                    bars: {
                        show: true,
                        align: "right",
                        barWidth: 0.2,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }];
                $scope.expensesByCategoryOptions.yaxis.ticks = labels;
                // By Cost Center Graph
                valuesa = [];
                valuesb = [];
                labels = [];
                angular.forEach(response.data.expensesByCostCenter.graph.values.a, function(value, key) {
                    valuesa.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByCostCenter.graph.values.b, function(value, key) {
                    valuesb.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByCostCenter.graph.labels, function(value, key) {
                    labels.push(value);
                });
                $scope.expensesByCostCenter = [{
                    label: vm.semesterASelected.name,
                    data: valuesa,
                    bars : {
                        show: true,
                        align: "left",
                        barWidth: 0.2,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }, {
                    label: vm.semesterBSelected.name,
                    data: valuesb,
                    bars: {
                        show: true,
                        align: "right",
                        barWidth: 0.2,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }];
                $scope.expensesByCostCenterOptions.yaxis.ticks = labels;
                // By Payee
                valuesa = [];
                valuesb = [];
                labels = [];
                angular.forEach(response.data.expensesByPayee.graph.values.a, function(value, key) {
                    valuesa.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByPayee.graph.values.b, function(value, key) {
                    valuesb.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByPayee.graph.labels, function(value, key) {
                    labels.push(value);
                });
                $scope.expensesByPayee = [{
                    label: vm.semesterASelected.name,
                    data: valuesa,
                    bars : {
                        show: true,
                        align: "left",
                        barWidth: 0.2,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }, {
                    label: vm.semesterBSelected.name,
                    data: valuesb,
                    bars: {
                        show: true,
                        align: "right",
                        barWidth: 0.2,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }];
                $scope.expensesByPayeeOptions.yaxis.ticks = labels;
                // By Bank Account
                valuesa = [];
                valuesb = [];
                labels = [];
                angular.forEach(response.data.expensesByBankAccount.graph.values.a, function(value, key) {
                    valuesa.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByBankAccount.graph.values.b, function(value, key) {
                    valuesb.push([value[0], value[1]]);
                });
                angular.forEach(response.data.expensesByBankAccount.graph.labels, function(value, key) {
                    labels.push(value);
                });
                $scope.expensesByBankAccount = [{
                    label: vm.semesterASelected.name,
                    data: valuesa,
                    bars : {
                        show: true,
                        align: "left",
                        barWidth: 0.2,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }, {
                    label: vm.semesterBSelected.name,
                    data: valuesb,
                    bars: {
                        show: true,
                        align: "right",
                        barWidth: 0.2,
                        lineWidth: 1,
                        horizontal: true,
                        fill: 1,
                        tooltip: true
                    }
                }];
                $scope.expensesByBankAccountOptions.yaxis.ticks = labels;
            });
        }

        function selectSemesters () {
            vm.query = {};
            vm.query['expos_ids'] = vm.expoSelected;
            ExpensesService.getExpenseSemesters(vm.query).then(function(response){
                vm.semesters = response.data;
            }).catch(function(err) {
            });
        }

        function selectCategories () {
            vm.query = {};
            vm.query['semesterA'] = vm.semesterASelected;
            vm.query['semesterB'] = vm.semesterASelected;
            vm.query['costCenter'] = vm.costCenterSelected;
            ExpensesService.getCategoriesForSelect(vm.query).then(function(response){
                vm.categories = response.data;
            }).catch(function(err) {
            });
        }        

        function formatPercent(input)
        {
            return input + '%';
        }

        function modal(items) {

            $uibModal.open({
                templateUrl: 'templates/expenses/reports/expensescomparative/template.modal.html',
                controller: 'ExpensesComparativeDetailsController',
                controllerAs:'vm',
                resolve:
                    {
                        items : function () {
                            return items;
                        },
                        semesterA : function () {
                            return vm.semesterASelected;
                        },
                        semesterB : function () {
                            return vm.semesterBSelected;
                        }
                    }
            });
        }

        activate();
    }
})();